import { Injectable, ComponentRef, ViewContainerRef, Injector } from '@angular/core';

export abstract class EntityRowRenderer {
  abstract render(entity: any, container: ViewContainerRef, injector?: Injector): ComponentRef<any>;
  abstract canRender(entityType: string): boolean;
}

@Injectable({
  providedIn: 'root'
})
export class EntityRowRegistry {
  private renderers: EntityRowRenderer[] = [];

  register(renderer: EntityRowRenderer): void {
    this.renderers.push(renderer);
  }

  getRenderer(entityType: string): EntityRowRenderer | undefined {
    return this.renderers.find(renderer => renderer.canRender(entityType));
  }

  getAllRenderers(): EntityRowRenderer[] {
    return [...this.renderers];
  }
}
